export default __webpack_public_path__ + "static/media/good.be22e5b6.png";